export default "__VITE_ASSET__fMV6Spo3__"